<div class="modal-form">
    <h2 class="jumbotron-heading" style="margin-left: 24px !important">Add Property</h2>

    <mat-dialog-content class="mat-typography">
        <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>
        <h4><strong>Client: {{ data?.name }}</strong></h4>
        <div class="edit">
            <form [formGroup]="propertyInfoForm">

                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <mat-radio-group aria-label="Select an option" formControlName="isOwnedProperty">
                            <mat-radio-button [value]="true">Owned Property</mat-radio-button>
                            <mat-radio-button [value]="false">Prospect Property</mat-radio-button>
                        </mat-radio-group>
                        <mat-error *ngIf="propertyInfoForm.controls.isOwnedProperty.errors?.required">
                            Please select one of these options
                        </mat-error>
                    </div>

                </div>
                <div class="Vert-10"></div>


                <div>
                    <div class="row">
                        <div class="col-12">
                            <lus-address-auto-complete [addressControl]="selectedAddressControl"
                                [unitNumberControl]="unitNumberControl"
                                [zipControl]="zipControl"></lus-address-auto-complete>
                        </div>
                    </div>


                    <ng-container *ngIf="propertyInfoForm.controls.isOwnedProperty.value === false">
                        <div class="row">
                            <div class="col-6">
                                <mat-form-field appearance="outline" floatLabel="always">
                                    <mat-label>Property Type</mat-label>
                                    <mat-select formControlName="propertyType" required>
                                        <mat-option *ngFor="let type of (propertyTypes$ | async)" [value]="type">
                                            {{type.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="propertyInfoForm.controls.propertyType.errors?.required">
                                        Please select one option from the dropdown
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-6">
                                <mat-form-field appearance="outline" floatLabel="always">
                                    <mat-label>Listing Price</mat-label>
                                    <input type="number" matInput formControlName="listingPrice" required>
                                    <span matPrefix>$&nbsp;</span>
                                    <mat-error *ngIf="propertyInfoForm.controls.listingPrice.errors?.required">
                                        Listing Price is required
                                    </mat-error>
                                    <mat-error *ngIf="!propertyInfoForm.controls.listingPrice.errors?.required
                                             && propertyInfoForm.controls.listingPrice.invalid">
                                        Value must be greater than 0
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-container>



                    <div class="Vert-10"></div>

                    <div class="row">
                        <div class="col-6">
                            <mat-slide-toggle *ngIf="showPrimaryPropertyToggle" formControlName="primaryProperty">This
                                is the client's primary
                                property</mat-slide-toggle>
                        </div>
                        <div class="col-6" align="end">

                            <button mat-button class="btn btn-primary float-end" (click)="onSubmit()"
                                [disabled]="(isLoading$ | async) || !propertyInfoForm.valid">Submit</button>

                            <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                                style="margin-right:10px;">
                                Cancel
                            </button>
                        </div>
                    </div>


                </div>

            </form>
        </div>


    </mat-dialog-content>

    <!--<mat-dialog-actions class="dialog-actions" align="end">
        <button mat-stroked-button (click)="onCancel()">
            Cancel
        </button>
        <button mat-stroked-button (click)="onSuccess()">
            Success
        </button>
    </mat-dialog-actions>-->
</div>